import { useState } from 'react'
import { PageProps } from 'gatsby'
import { CustomerUpdateInput } from 'lib/graphql/storeadmin'
import { customerErrorHandling, useCustomer } from 'lib/hooks'
import { Error, SEO, showMessage } from 'components/common'
import { Editor } from 'components/customers'

export const Head = () => <SEO title="顧客（個人）編集" />

const PersonalEditPage = ({
  params: { id },
}: PageProps<Queries.Query>): JSX.Element => {
  const [requesting, setRequesting] = useState(false)
  const { customer, update, error, loading } = useCustomer(id)

  // Customer Personal error useState
  const [showCustomerErrorAlert, setShowCustomerErrorAlert] = useState(false)
  const [customerErrorDescription, setCustomerErrorDescription] = useState([])

  const onFinish = async (
    allowDuplicate = true,
    values: CustomerUpdateInput
  ) => {
    setRequesting(true)
    try {
      const { data, error } = await update({
        allowDuplicate: true,
        input: values,
      })
      const userErrors = data?.customerUpdate?.customerUserErrors || []
      if (userErrors.length > 0) {
        setShowCustomerErrorAlert(true)
        const errorMessages = customerErrorHandling(userErrors)
        setCustomerErrorDescription(errorMessages)
        showMessage('error', 'エラーが発生しました。')
      } else if (error) {
        showMessage('error', 'エラーが発生しました。')
      } else {
        setShowCustomerErrorAlert(false)
        showMessage('success', '顧客情報を編集しました。')
      }
    } catch (e) {
      setShowCustomerErrorAlert(true)
      setCustomerErrorDescription(e.message)
      showMessage('error', 'サーバーとの通信時にエラーが発生しました。')
    } finally {
      setRequesting(false)
    }
  }
  const onCloseAlert = () => {
    setShowCustomerErrorAlert(false)
  }

  if (error) {
    return Error.render(error)
  }

  return (
    <>
      <Editor
        title={`${customer?.lastName} ${customer?.firstName}`}
        type="personal"
        defaultValues={{
          phone: customer?.phone,
          note: customer?.note,
          zip: customer?.address?.zip,
          corporationName: customer?.corporationName,
          corporationNameKana: customer?.corporationNameKana,
          firstName: customer?.firstName,
          lastName: customer?.lastName,
          email: customer?.email,
          city: customer?.address?.city,
          prefectureCode: customer?.address?.prefectureCode,
          address1: customer?.address?.address1,
          address2: customer?.address?.address2,
          discount: customer?.userMetaData?.discount,
          limit: customer?.userMetaData?.limit,
          bookableFlag: customer?.bookableFlag,
        }}
        loading={loading}
        requesting={requesting}
        onFinish={onFinish}
        showAlert={showCustomerErrorAlert}
        onCloseAlert={onCloseAlert}
        alertDescription={customerErrorDescription}
      />
    </>
  )
}

export default PersonalEditPage
